<template>
  <v-select
    :class="isMobile ? 'selectRoleMobile' : 'selectRole'"
    :items="userBranches"
    item-text="text"
    item-value="index"
    v-model="currentRoleIndex"
    v-if="userBranches.length > 0"
    @change="setCurrentRole"
  ></v-select>
</template>

<script>
import { setCurrentBranch, setCurrentRole } from "@/utils/auth";
import Vue from "vue";
export default {
  data() {
    return {
      currentRoleIndex: -1,
      userBranches: [],
    };
  },
  created() {
    const ub = [
      ...this.$store.getters.branches,
      ...this.$store.getters.permissions,
    ];
    let index = 0;
    ub.forEach((element) => {
      element["index"] = index++;
      if ("KPrice" in element) {
        element["text"] =
          this.getItemDesc(element.KPrice) + " در " + element.BranchName;
        element["type"] = "enduser";
      } else {
        element["text"] =
          this.getItemRole(element.Role) + " در " + element.BranchName;
        element["type"] = "role";
      }
    });
    this.userBranches = [...ub];

    if (ub.length > 0) {
      if (this.currentRole) {
        this.currentRoleIndex = this.currentRole.index;
      } else {
        this.currentRoleIndex = 0;
        this.setCurrentRole(ub[0]);
      }
    }

    //if (this.currentRole) this.currentRoleIndex = this.currentRole.index;
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },

    currentRole() {
      return this.$store.getters.currentRole;
    },
  },
  methods: {
    getItemDesc(kprice) {
      switch (kprice) {
        case 1:
          return "طلبه";
        case 2:
          return "استاد";
        case 3:
          return "پرسنل";
        case 4:
          return "آزاد";
        default:
          return "سایر";
      }
    },
    getItemRole(role) {
      switch (role) {
        case 1:
          return "مدیر";
        case 2:
          return "حسابدار";
        case 3:
          return "آشپز";
        default:
          return "";
      }
    },
    setCurrentRole() {
      const currentRole = this.userBranches[this.currentRoleIndex];
      setCurrentRole(currentRole);
      let nextPath = "";
      var isRole = "KPrice" in currentRole;
      let isMobile = Vue.prototype.$mobile;
      if (isRole) {
        setCurrentBranch("");
      } else {
        setCurrentBranch({ id: currentRole.BranchID });
      }
      if (isMobile) {
        nextPath = "/index";
      } else if (isRole) {
        nextPath = "/reserve";
      } else if (currentRole.Role < 3) {
        nextPath = "/branch/menus";
      } else {
        nextPath = "/branch/orders";
      }

      window.location = nextPath;
    },
  },
};
</script>
<style>
.selectRole {
  width: 300px !important;
}
.selectRole .v-select__selection,
.selectRole .v-icon,
.selectRoleMobile .v-select__selection,
.selectRoleMobile .v-icon {
  color: white !important;
}

.selectRole .v-select__selections {
  font-size: 16px;
}

.selectRoleMobile {
  width: 220px !important;
}

.selectRoleMobile .v-select__selections {
  font-size: 14px;
}
</style>
